import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { Location } from "@angular/common";


@Component({
  selector: "app-loan-defer-instalment",
  templateUrl: "./loan-defer-instalment.component.html",
  standalone:false,
  styleUrls: ["./loan-defer-instalment.component.scss"],
})
export class LoanDeferInstalmentComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private location: Location
  ) {
    // this.toastr.success(
    //   "You have succesfully added nickname to your selected loan",
    //   "Loan Nickname Added"
    // );
  }
  loanDeferUploadDoc() {
    this.router.navigateByUrl("/LoanDeferUploadDoc");
  }

  ngOnInit(): void {}

  showModal(num) {
    this.modalObservable.next(num);
  }
  back() {
    this.location.back();
  }
}
